import React from 'react';
import { renderTemplate } from '../utils/templateEngine';
import { useAppStore } from '../state/AppStore';

// Выделение в тексте: *термин* → жирный, цвет primary, кликабельный (вопрос AI).
const TERM = /(\*[^*\n]+\*)/g;

/**
 * Рендерит текст экрана: подставляет {{переменные}} и превращает *термин*
 * в кликабельный акцент. Клик по акценту задаёт вопрос AI-ассистенту.
 */
export default function RichText({ text, variables = {} }) {
  const { actions, config } = useAppStore();
  const glossary = (config && config.glossary) || {};
  const rendered = renderTemplate(text, variables);
  if (!rendered) return null;

  const nodes = [];
  rendered.split(TERM).forEach((part, i) => {
    const match = /^\*([^*\n]+)\*$/.exec(part);
    if (match) {
      // Синтаксис выделения:
      //   *слово#id*  — обращение к глоссарию по id (слово может склоняться как угодно)
      //   *слово*     — без id: дефолтный вопрос к AI
      // Запись глоссария сама решает: answer — показать зашитый ответ; question — спросить AI.
      const raw = match[1];
      const hash = raw.indexOf('#');
      const term = (hash === -1 ? raw : raw.slice(0, hash)).trim();
      const entry = hash === -1 ? null : glossary[raw.slice(hash + 1).trim()];
      const payload = { term, answer: null, question: null };
      if (typeof entry === 'string') {
        payload.question = entry;
      } else if (entry) {
        payload.answer = entry.answer || null;
        payload.question = entry.question || null;
      }
      nodes.push(
        <span
          key={`term-${i}`}
          className="ai-term"
          role="button"
          tabIndex={0}
          onClick={() => actions.askAssistant(payload)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              actions.askAssistant(payload);
            }
          }}
        >
          {term}
        </span>
      );
      return;
    }
    if (!part) return;
    // Обычный текст: переносы строк \n → <br/>.
    part.split('\n').forEach((line, j) => {
      if (j > 0) nodes.push(<br key={`br-${i}-${j}`} />);
      if (line) nodes.push(<React.Fragment key={`text-${i}-${j}`}>{line}</React.Fragment>);
    });
  });
  return nodes;
}
